import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { provideDefaultConfigFactory } from '../config/config-providers';
import { defaultGlobalMessageConfigFactory } from './config/default-global-message-config';
import { errorHandlers, httpErrorInterceptors } from './http-interceptors/index';
import { GlobalMessageEffect } from './store/effects/global-message.effect';
import { GlobalMessageStoreModule } from './store/global-message-store.module';

@NgModule({
  imports: [GlobalMessageStoreModule, EffectsModule.forFeature([GlobalMessageEffect])],
  providers: [provideDefaultConfigFactory(defaultGlobalMessageConfigFactory)],
})
export class GlobalMessageModule {
  static forRoot(): ModuleWithProviders<GlobalMessageModule> {
    return {
      ngModule: GlobalMessageModule,
      providers: [...errorHandlers, ...httpErrorInterceptors],
    };
  }
}
